<template>
  <div class="component-box">
    <h1>Bringing AI to Token Launchpad.</h1>

    <n-card title="FACE-ID">
      <template #cover>
        <n-carousel show-arrow>
          <img
            class="carousel-img"
            src="https://ice.frostsky.com/2024/08/11/079c13cd08df740fb9e00ebc4a414859.jpeg"
          />
          <img
            class="carousel-img"
            src="https://ice.frostsky.com/2024/08/11/7d69c0bd5c29764300523f3cc5474b33.jpeg"
          />
          <img
            class="carousel-img"
            src="https://ice.frostsky.com/2024/08/11/38d1def6b6ffcfad997b666bcc5bd5e3.jpeg"
          />
        </n-carousel>
      </template>
      First Token distribution by face recognition build on the Internet Computer.<br />
      Use on-chain facial recognition to achieve the fairest token distribution.
    </n-card>
    <n-divider />
    <n-button @click="$router.push('/claim')">CLAIM</n-button>
  </div>
  <n-divider />
  <n-card title="Token - List">
    <n-data-table :columns="columns" :data="data" :pagination="pagination" :bordered="false" />
    <n-divider />
    <n-button @click="$router.push('/deploy')">DEPLOY</n-button>
  </n-card>
</template>

<script setup>
import { ref, h } from "vue";
import { NButton } from "naive-ui";

function createColumns() {
  return [
    {
      title: "No",
      key: "no",
    },
    {
      title: "ID",
      key: "ID",
    },
    {
      title: "NUM",
      key: "NUM",
    },
    {
      title: "Action",
      key: "actions",
      render(row) {
        return h(
          NButton,
          {
            strong: true,
            tertiary: true,
            size: "small",
            onClick: () => window.location.href = window.location.origin + '/claim'  
          },
          { default: () => "GET" }
        );
      },
    },
  ];
}

const data = ref([
  { no: 1, ID: "FACEID", NUM: "1000000000" },
  { no: 2, ID: "More", NUM: "10000" },
  { no: null, ID: "...", NUM: "..." },
]);

const columns = createColumns();
const pagination = ref(false);
</script>
